import { $ } from "@/common/Axios";

export default {
  /**
   * 中军考勤
   */
  armyAttendance: {
    /*
     * 新增考勤
     * attendanceData 考勤数据 (string query )
     * attendanceDate 考勤日期 (string query )
     * attendanceImage 考勤图片 (string query )
     * classId 班级id (integer query )
     * createId 添加人id (integer query )
     * finishCount 到课人数 (integer query )
     * id  (integer query )
     * unfinishCount 未到人数 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyAttendance", p, c),

    /*
     * 删除考勤
     * id 考勤id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyAttendance", p, c),
  },
  armyAttendance_exportInfo: {
    /*
     * 导出考勤情况
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyAttendance/exportInfo", p, c),
  },
  armyAttendance_exportRecord: {
    /*
     * 导出考勤记录
     * id 考勤id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyAttendance/exportRecord", p, c),
  },
  armyAttendance_listByClassId: {
    /*
     * 根据班级获取考勤列表
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyAttendance/listByClassId", p, c),
  },
  armyAttendance_uploadRecord: {
    /*
     * 上传考勤记录
     * file file (file formData required)
     * id 考勤id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyAttendance/uploadRecord", p, c),
  },

  /**
   * 中军学生证书
   */
  armyCert: {
    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyCert", p, c),
  },
  armyCert_create: {
    /*
     * 生成中军学生证书
     * cerTime 证书时间，默认当前 (string query )
     * label 标签 (string query )
     * studentIds 学生ids (array query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyCert/create", p, c),
  },
  armyCert_exportForAdapt: {
    /*
     * 导出（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCert/exportForAdapt", p, c),
  },
  armyCert_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCert/listForAdapt", p, c),
  },
  armyCert_listForClient: {
    /*
     * 列表（客户端）
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyCert/listForClient", p, c),
  },

  /**
   * 证书标准
   */
  armyCertStandards: {
    /*
     * 添加
     * configId 报名配置id (integer query )
     * id  (integer query )
     * name 证书名称 (string query )
     * templateFile 模板文件 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyCertStandards", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyCertStandards", p, c),
  },
  armyCertStandards_list: {
    /*
     * 列表
     * configId 配置id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyCertStandards/list", p, c),
  },

  /**
   * 中军章节
   */
  armyChapter: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * duration 时长 (integer query )
     * endPage 结束页码 (integer query )
     * id  (integer query )
     * name 章节名称 (string query )
     * sort 排序 (integer query )
     * startPage 开始页码 (integer query )
     * type 类型：事务员培训、职业技能培训、适应性培训 (string query )
     * videoId 课件id (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyChapter", p, c),
  },
  armyChapter_copy: {
    /*
     * 复制
     * courseId 课程id (integer query required)
     * targetCourseId 目标课程id (integer query )
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyChapter/copy", p, c),
  },
  armyChapter_getLasterVideoIdForClient: {
    /*
     * 获取最新视频id
     * type 类型：事务员培训、职业技能培训 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyChapter/getLasterVideoIdForClient", p, c),
  },
  armyChapter_listAdaptForClient: {
    /*
     * 适应性培训章节列表(客户端)
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listAdaptForClient", p, c),
  },
  armyChapter_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listForAdapt", p, c),
  },
  armyChapter_listForOther: {
    /*
     * 列表（其他培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listForOther", p, c),
  },
  armyChapter_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * chapterType 章节类型：习题、视频 (string query required)
     * classId 班级id (integer query )
     * courseId 课程id (integer query )
     * type 类型：事务员培训、职业技能培训、适应性培训 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listSimple", p, c),
  },
  armyChapter_listSubjectForClerk: {
    /*
     * 习题列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listSubjectForClerk", p, c),
  },
  armyChapter_listSubjectForClient: {
    /*
     * 习题章节简易列表(事务员和职业技能客户端)
     * type 类型：事务员培训、职业技能培训 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyChapter/listSubjectForClient", p, c),
  },
  armyChapter_listSubjectForOfficer: {
    /*
     * 习题列表（转业士官培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyChapter/listSubjectForOfficer", p, c),
  },
  armyChapter_listSubjectForSkill: {
    /*
     * 习题列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listSubjectForSkill", p, c),
  },
  armyChapter_listVideoForClerk: {
    /*
     * 视频列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listVideoForClerk", p, c),
  },
  armyChapter_listVideoForClient: {
    /*
     * 习题章节简易列表(事务员和职业技能客户端)
     * type 类型：事务员培训、职业技能培训 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listVideoForClient", p, c),
  },
  armyChapter_listVideoForOfficer: {
    /*
     * 视频列表（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listVideoForOfficer", p, c),
  },
  armyChapter_listVideoForSkill: {
    /*
     * 视频列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyChapter/listVideoForSkill", p, c),
  },

  /**
   * 中军班级
   */
  armyClass: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * bookId 台账id (integer query )
     * contactWay 联系方式 (string query )
     * endTime 结束时间 (string query )
     * headerTeacherId 班主任 (integer query )
     * id  (integer query )
     * name 班级名称 (string query )
     * otherProjectIds 其他项目id (string query )
     * projectId 项目id (integer query )
     * startTime 开始时间 (string query )
     * studyContentIds 学习内容id (string query )
     * type 班级类型：适应性培训专用 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyClass", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyClass", p, c),
  },
  armyClass_disableClass: {
    /*
     * 禁用到期班级
     */
    put: (p, c) => $.put("/api/cms/army/armyClass/disableClass", p, c),
  },
  armyClass_editBook: {
    /*
     * 上传台账
     * bookId 台账id (integer query required)
     * id 班级id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyClass/editBook", p, c),
  },
  armyClass_editBookByFinance: {
    /*
     * 财务上传台账
     * bookId 台账id (integer query required)
     * id 班级id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyClass/editBookByFinance", p, c),
  },
  armyClass_exportForAdapt: {
    /*
     * 导出（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/exportForAdapt", p, c),
  },
  armyClass_exportForClerk: {
    /*
     * 导出（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/exportForClerk", p, c),
  },
  armyClass_exportForOfficer: {
    /*
     * 导出（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/exportForOfficer", p, c),
  },
  armyClass_exportForOther: {
    /*
     * 导出（其他）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/exportForOther", p, c),
  },
  armyClass_exportForSkill: {
    /*
     * 导出（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/exportForSkill", p, c),
  },
  armyClass_getAdultFollowConfig: {
    /*
     * 获取成教催费配置
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/getAdultFollowConfig", p, c),
  },
  armyClass_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listForAdapt", p, c),
  },
  armyClass_listForClerk: {
    /*
     * 列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listForClerk", p, c),
  },
  armyClass_listForOfficer: {
    /*
     * 列表（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listForOfficer", p, c),
  },
  armyClass_listForOther: {
    /*
     * 列表（其他）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listForOther", p, c),
  },
  armyClass_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listForSkill", p, c),
  },
  armyClass_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * businessType 业务类型 (string query required)
     * city 市 (string query )
     * month 月份 (string query )
     * province 省份 (string query )
     * year 年份 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listSimple", p, c),
  },
  armyClass_listSimpleByProject: {
    /*
     * /根据项目获取班级列表
     * projectId 项目id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listSimpleByProject", p, c),
  },
  armyClass_listStudyContentId: {
    /*
     * 获取学习内容id
     * id 班级id (integer query required)
     * type 类型：课程、习题、视频 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyClass/listStudyContentId", p, c),
  },
  armyClass_setAdultFollowConfig: {
    /*
     * 设置成教催费配置
     * current 是否当前催费 (string query )
     * feeType 缴费类型 (string query )
     * id id (string query )
     * name 催费名称 (string query )
     * operateType 操作类型：添加，修改，删除，清空 (string query )
     * rollGrade 学籍年级 (string query )
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyClass/setAdultFollowConfig", p, c),
  },
  armyClass_setStudyContentId: {
    /*
     * 设置学习内容id
     * id 班级id (integer query required)
     * studyContentIds 学习内容id (array query required)
     * type 类型：课程、习题、视频 (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyClass/setStudyContentId", p, c),
  },
  armyClass_uploadForAdapt: {
    /*
     * 批量导入（适应性培训）
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyClass/uploadForAdapt", p, c),
  },

  /**
   * 中军课程
   */
  armyCourse: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * adaptType 适应性培训课程类型：内部、通识 (string query )
     * coverId 封面id (integer query )
     * id  (integer query )
     * label 标签 (string query )
     * name 课程名称 (string query )
     * sort 排序 (integer query )
     * teacher 讲师 (string query )
     * teacherIntro 讲师介绍 (string query )
     * type 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyCourse", p, c),
  },
  armyCourse_changeCourse: {
    /*
     * 切换课程
     * courseId 课程id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyCourse/changeCourse", p, c),
  },
  armyCourse_detailsAdaptForClient: {
    /*
     * 详情（客户端）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyCourse/detailsAdaptForClient", p, c),
  },
  armyCourse_getCurrentCourseId: {
    /*
     * 获取当前课程Id
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/getCurrentCourseId", p, c),
  },
  armyCourse_listAdaptForClient: {
    /*
     * 简易列表（客户端）
     * adaptType 适应性培训课程类型：内部、通识 (string query required)
     * label 标签 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listAdaptForClient", p, c),
  },
  armyCourse_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listForAdapt", p, c),
  },
  armyCourse_listForOfficer: {
    /*
     * 列表（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listForOfficer", p, c),
  },
  armyCourse_listForOther: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listForOther", p, c),
  },
  armyCourse_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listForSkill", p, c),
  },
  armyCourse_listLabel: {
    /*
     * 标签列表（适应性培训）
     * adaptType 适应性培训课程：内部、通识 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listLabel", p, c),
  },
  armyCourse_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     * adaptType 适应性培训课程：内部、通识 (string query )
     * type 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listSimple", p, c),
  },
  armyCourse_listSimpleForClient: {
    /*
     * 简易列表（客户端）
     */
    get: (p, c) => $.get("/api/cms/army/armyCourse/listSimpleForClient", p, c),
  },

  /**
   * 中军费用信息
   */
  armyFeeInfo: {
    /*
     * 编辑
     * id  (integer query )
     * settleStatus 是否已完成结算 (string query )
     * studentId 学生id (integer query )
     * subsidyAmount 已补贴金额 (number query )
     * subsidyFee 应补贴金额 (number query )
     */
    put: (p, c) => $.put("/api/cms/army/armyFeeInfo", p, c),
  },
  armyFeeInfo_batchUpdateStatus: {
    /*
     * 批量修改结算状态
     * ids id (array query required)
     * settleStatus 结算状态 (string query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyFeeInfo/batchUpdateStatus", p, c),
  },
  armyFeeInfo_exportSettleForSkill: {
    /*
     * 结算列表导出（职业技能培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyFeeInfo/exportSettleForSkill", p, c),
  },
  armyFeeInfo_exportSubsidyForSkill: {
    /*
     * 补贴列表导出（职业技能培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyFeeInfo/exportSubsidyForSkill", p, c),
  },
  armyFeeInfo_listSettleForSkill: {
    /*
     * 结算列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyFeeInfo/listSettleForSkill", p, c),
  },
  armyFeeInfo_listSubsidyForSkill: {
    /*
     * 补贴列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyFeeInfo/listSubsidyForSkill", p, c),
  },
  armyFeeInfo_uploadSubsidyForSkill: {
    /*
     * 导入补贴列表（职业技能培训）
     * file file (file formData required)
     * uploadType 导入类型：新增、覆盖 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyFeeInfo/uploadSubsidyForSkill", p, c),
  },

  /**
   * 中军模拟试卷
   */
  armyMockPaper: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * classId 班级id (integer query )
     * content 内容 (string query )
     * contentType 内容类型：客观，主观 (string query )
     * courseId 课程id (integer query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名字 (string query )
     * shuffle 是否打乱顺序 (string query )
     * startTime 开始时间 (string query )
     * suggestedDuration 建议答题时长 (integer query )
     * type 类型：模拟练习，全真模拟 (string query )
     * wordTime 打字题时间 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyMockPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyMockPaper", p, c),
  },
  armyMockPaper_copySubject: {
    /*
     * 复制题目
     * sourceId 源试卷id (integer query required)
     * targetId 目标试卷id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyMockPaper/copySubject", p, c),
  },
  armyMockPaper_detailsById: {
    /*
     * 详情(有答题id的传，表示已答题，返回学生当时答题情况，不可重复答题（前端控制）)
     * id id (integer query required)
     * studentPaperId 学生答题id (integer query )
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/detailsById", p, c),
  },
  armyMockPaper_exportScores: {
    /*
     * 导出成绩
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/exportScores", p, c),
  },
  armyMockPaper_listPracticeForClerk: {
    /*
     * 模拟练习列表（事务员培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyMockPaper/listPracticeForClerk", p, c),
  },
  armyMockPaper_listPracticeForClient: {
    /*
     * C端模拟练习列表（每次模拟只能答题一次，因此没有答题记录列表，答题记录id在该接口体现）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyMockPaper/listPracticeForClient", p, c),
  },
  armyMockPaper_listPracticeForOfficer: {
    /*
     * 模拟练习列表（转业士官培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyMockPaper/listPracticeForOfficer", p, c),
  },
  armyMockPaper_listPracticeForSkill: {
    /*
     * 模拟练习列表（职业技能培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyMockPaper/listPracticeForSkill", p, c),
  },
  armyMockPaper_listRealForClerk: {
    /*
     * 全真模拟列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/listRealForClerk", p, c),
  },
  armyMockPaper_listRealForClient: {
    /*
     * C端全真模拟答题列表（全真模拟列表）
     * type 类型：当天、记录 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/listRealForClient", p, c),
  },
  armyMockPaper_listRealForOfficer: {
    /*
     * 正式考试列表（转业士官培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyMockPaper/listRealForOfficer", p, c),
  },
  armyMockPaper_listRealForSkill: {
    /*
     * 正式考试列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/listRealForSkill", p, c),
  },
  armyMockPaper_listSimple: {
    /*
     * 简易列表
     * classId 班级id (integer query required)
     * courseId 课程id (integer query )
     * type 类型：模拟练习，全真模拟 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyMockPaper/listSimple", p, c),
  },

  /**
   * 军人项目进度
   */
  armyProject: {
    /*
     * 添加
     * adminId 拓展人id (integer query )
     * agreementId 盖章合同id (integer query )
     * approvalInstanceId 审批实例id (integer query )
     * approximateId 概算表id (integer query )
     * businessType 业务类型 (string query )
     * city 市 (string query )
     * coverId 封面id (integer query )
     * district 区 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * intro 项目介绍 (string query )
     * month 月份 (string query )
     * province 省份 (string query )
     * settlementStatus 结算状态 (string query )
     * startTime 开始时间 (string query )
     * status 项目状态 (string query )
     * title 标题 (string query )
     * traineeNumber 培训人数 (integer query )
     * trainingCost 培训总费用（单位：元） (number query )
     * trainingPeriod 预计培训周期（单位：天） (number query )
     * year 年份 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyProject", p, c),
  },
  armyProject_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/details", p, c),
  },
  armyProject_detailsForClient: {
    /*
     * C端口详情（适应性培训使用）
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/detailsForClient", p, c),
  },
  armyProject_detailsSimple: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/detailsSimple", p, c),
  },
  armyProject_editAgreement: {
    /*
     * 上传合同
     * agreementId 合同资源id (integer query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProject/editAgreement", p, c),
  },
  armyProject_editSettlementStatus: {
    /*
     * 修改结算状态
     * agreementId 合同资源id (integer query required)
     * id id (integer query required)
     * settlementStatus 结算状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyProject/editSettlementStatus", p, c),
  },
  armyProject_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/export", p, c),
  },
  armyProject_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/list", p, c),
  },
  armyProject_listCity: {
    /*
     * 地级市列表
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listCity", p, c),
  },
  armyProject_listDistrict: {
    /*
     * 区县列表
     * city 地级市 (string query required)
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listDistrict", p, c),
  },
  armyProject_listForClient: {
    /*
     * C端口列表
     * businessType 业务类型 (string query required)
     * city 市 (string query )
     * province 省份 (string query )
     * statuses 项目状态 (array query required)
     * year 年份 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listForClient", p, c),
  },
  armyProject_listForWebSite: {
    /*
     * 项目列表（官网使用）
     * businessType 业务类型 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listForWebSite", p, c),
  },
  armyProject_listMonth: {
    /*
     * 月份列表
     * businessType 业务类型 (string query required)
     * year 年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listMonth", p, c),
  },
  armyProject_listOther: {
    /*
     * 其他已成功列表（包含已明确合作、已完成培训两种状态）
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listOther", p, c),
  },
  armyProject_listProvince: {
    /*
     * 省份列表
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listProvince", p, c),
  },
  armyProject_listReginAdmin: {
    /*
     * 区域负责列表
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listReginAdmin", p, c),
  },
  armyProject_listSimple: {
    /*
     * 简易列表（已明确合作的）
     * businessType 业务类型 (string query required)
     * city 地级市 (string query required)
     * month 月份 (string query )
     * province 省份 (string query required)
     * year 年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listSimple", p, c),
  },
  armyProject_listYear: {
    /*
     * 年份列表
     * businessType 业务类型 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyProject/listYear", p, c),
  },
  armyProject_setReginAdmin: {
    /*
     * 设置区域负责
     * regionalAdmins 区域负责列表 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyProject/setReginAdmin", p, c),
  },
  armyProject_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyProject/upload", p, c),
  },

  /**
   * 军人项目成本
   */
  armyProjectCost: {
    /*
     * 添加
     * content 具体内容 (string query )
     * estimatedCost 预算成本 (number query )
     * id  (integer query )
     * projectFinanceId 中军项目财务id (integer query )
     * type 成本类型：通过配置 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyProjectCost", p, c),

    /*
     * 删除
     * id id (integer query )
     */
    delete: (p, c) => $.delete("/api/cms/army/armyProjectCost", p, c),
  },
  armyProjectCost_list: {
    /*
     * 列表
     * financeId 资金id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectCost/list", p, c),
  },

  /**
   * 军人项目成本明细
   */
  armyProjectCostItem: {
    /*
     * 删除
     * ids ids (array query )
     */
    delete: (p, c) => $.delete("/api/cms/army/armyProjectCostItem", p, c),
  },
  armyProjectCostItem_apply: {
    /*
     * 申请
     * amount 金额 (number query required)
     * costId 成本id (integer query required)
     * costTime 成本时间 (string query required)
     * remark 备注 (string query required)
     * type 类型：学校支付/扣款，中军支付 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyProjectCostItem/apply", p, c),
  },
  armyProjectCostItem_audit: {
    /*
     * 审核
     * auditStatus 审核状态：通过、拒绝 (string query required)
     * id id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectCostItem/audit", p, c),
  },
  armyProjectCostItem_editByApply: {
    /*
     * 编辑（申请人编辑）（只能申请人(或上级)自己编辑拒绝的）
     * amount 金额 (number query required)
     * costTime 成本时间 (string query required)
     * id id (integer query required)
     * remark 备注 (string query required)
     * type 类型：学校支付/扣款，中军支付 (string query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectCostItem/editByApply", p, c),
  },
  armyProjectCostItem_editByFinance: {
    /*
     * 编辑（财务编辑）
     * amount 金额 (number query )
     * applyId 申请人 (integer query )
     * applyTime 申请时间 (string query )
     * auditId 审核人 (integer query )
     * auditRemark 审核备注 (string query )
     * auditStatus 审核状态 (string query )
     * auditTime 审核时间 (string query )
     * costTime 成本时间 (string query )
     * id  (integer query )
     * projectCostId 中军项目成本id (integer query )
     * remark 备注 (string query )
     * type 成本明细类型：学校支付/扣款，中军支付 (string query )
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyProjectCostItem/editByFinance", p, c),
  },
  armyProjectCostItem_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectCostItem/export", p, c),
  },
  armyProjectCostItem_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectCostItem/list", p, c),
  },

  /**
   * 军人项目财务
   */
  armyProjectFinance_apply: {
    /*
     * 申请
     * classId 班级id (integer query required)
     * docking 对接事务局/学校 (string query required)
     * estimatedSettleAmount 预计结算金额 (number query required)
     * file file (file formData required)
     * projectId 项目id (integer query required)
     * settleCount 结算人数 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyProjectFinance/apply", p, c),
  },
  armyProjectFinance_audit: {
    /*
     * 审核
     * auditStatus 审核状态：通过、拒绝 (string query required)
     * docking 对接事务局/学校 (string query )
     * estimatedSettleAmount 预计结算金额 (number query )
     * id id (integer query required)
     * remark 备注，拒绝的时候必填 (string query )
     * settleCount 结算人数 (integer query )
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectFinance/audit", p, c),
  },
  armyProjectFinance_details: {
    /*
     * details
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectFinance/details", p, c),
  },
  armyProjectFinance_downloadCostModule: {
    /*
     * 下载成本模板
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyProjectFinance/downloadCostModule", p, c),
  },
  armyProjectFinance_editByApply: {
    /*
     * 编辑（申请人编辑）（只能申请人(或上级)自己编辑拒绝的）
     * docking 对接事务局/学校 (string query required)
     * estimatedSettleAmount 预计结算金额 (number query required)
     * id id (integer query required)
     * settleCount 结算人数 (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectFinance/editByApply", p, c),
  },
  armyProjectFinance_editByFinance: {
    /*
     * 编辑（财务编辑）
     * applyId 申请人 (integer query )
     * applyTime 申请时间 (string query )
     * auditId 审核人 (integer query )
     * auditRemark 审核备注 (string query )
     * auditTime 审核时间 (string query )
     * classId 班级id (integer query )
     * docking 对接方(事务局/学校) (string query )
     * estimatedSettleAmount 预计结算金额 (number query )
     * id  (integer query )
     * projectId 项目id (integer query )
     * realSettleAmount 实际结算金额 (number query )
     * settleCount 结算人数 (integer query )
     * status 状态：预算审核中，预算通过、预算拒绝、完结 (string query )
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyProjectFinance/editByFinance", p, c),
  },
  armyProjectFinance_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectFinance/export", p, c),
  },
  armyProjectFinance_finish: {
    /*
     * 完结
     * id id (integer query required)
     * realSettleAmount 实际结算金额 (number query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectFinance/finish", p, c),
  },
  armyProjectFinance_getCostType: {
    /*
     * 获取成本类型
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectFinance/getCostType", p, c),
  },
  armyProjectFinance_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/army/armyProjectFinance/list", p, c),
  },
  armyProjectFinance_setCostType: {
    /*
     * 设置成本类型
     * types 类型 (array query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyProjectFinance/setCostType", p, c),
  },

  /**
   * 中军宣传内容
   */
  armyPublicityContent: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * businessType 业务类型 (string query )
     * content 内容 (string query )
     * contentType 内容类型：链接、富文本 (string query )
     * coverId 封面 (integer query )
     * id  (integer query )
     * publishTime 发布时间 (string query )
     * title 标题 (string query )
     * type 培训动态、就业创业指导、政策法规 (string query )
     * url 链接 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyPublicityContent", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyPublicityContent", p, c),
  },
  armyPublicityContent_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyPublicityContent/details", p, c),
  },
  armyPublicityContent_listCareerForAdapt: {
    /*
     * 列表（就业创业指导）（适应性培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyPublicityContent/listCareerForAdapt", p, c),
  },
  armyPublicityContent_listForClient: {
    /*
     * 列表（C端）
     * businessType 业务类型 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyPublicityContent/listForClient", p, c),
  },
  armyPublicityContent_listPolicyForAdapt: {
    /*
     * 列表（政策法规）（适应性培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyPublicityContent/listPolicyForAdapt", p, c),
  },
  armyPublicityContent_listTrainingForAdapt: {
    /*
     * 列表（培训动态）（适应性培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyPublicityContent/listTrainingForAdapt", p, c),
  },

  /**
   * 中军排班
   */
  armyScheduling: {
    /*
     * 添加
     * address 地址 (string query )
     * content 工作内容 (string query )
     * endTime 结束时间 (string query )
     * eventId 钉钉日日程id (string query )
     * id  (integer query )
     * joinMember 参与人员 (string query )
     * otherProjectIds 其他项目id (string query )
     * projectId 项目id (integer query )
     * startTime 开始时间 (string query )
     * weeklyRepeat 是否每周重复 (string query )
     * weeks 重复多少周 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyScheduling", p, c),

    /*
     * 更新
     * address 地址 (string query )
     * content 工作内容 (string query )
     * endTime 结束时间 (string query )
     * eventId 钉钉日日程id (string query )
     * id  (integer query )
     * joinMember 参与人员 (string query )
     * otherProjectIds 其他项目id (string query )
     * projectId 项目id (integer query )
     * startTime 开始时间 (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyScheduling", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyScheduling", p, c),
  },
  armyScheduling_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/army/armyScheduling/export", p, c),
  },
  armyScheduling_gantt: {
    /*
     * 甘特图
     * endTime 结束时间 (string query required)
     * startTime 开始时间 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyScheduling/gantt", p, c),
  },
  armyScheduling_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/army/armyScheduling/list", p, c),
  },
  armyScheduling_listAllAdminIds: {
    /*
     * 获取所有管理员id列表
     */
    get: (p, c) => $.get("/api/cms/army/armyScheduling/listAllAdminIds", p, c),
  },
  armyScheduling_listMemberIds: {
    /*
     * 获取成员id列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyScheduling/listMemberIds", p, c),
  },
  armyScheduling_setAllAdminIds: {
    /*
     * 设置所有管理员id列表
     * adminIds 成员ids (array query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyScheduling/setAllAdminIds", p, c),
  },
  armyScheduling_updateMember: {
    /*
     * 排班
     * ids ids (array query required)
     * memberIds 成员ids (array query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyScheduling/updateMember", p, c),
  },

  /**
   * 中军成绩
   */
  armyScore: {
    /*
     * 编辑
     * classId 班级id (integer query )
     * evaluate 评定成绩 (string query )
     * id  (integer query )
     * practiseScore 实操成绩 (number query )
     * studentId 学生id (integer query )
     * theoryScore 理论成绩 (number query )
     */
    put: (p, c) => $.put("/api/cms/army/armyScore", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyScore", p, c),
  },
  armyScore_downloadModule: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/downloadModule", p, c),
  },
  armyScore_exportForClerk: {
    /*
     * 导出（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/exportForClerk", p, c),
  },
  armyScore_exportForSkill: {
    /*
     * 导出（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/exportForSkill", p, c),
  },
  armyScore_listForClerk: {
    /*
     * 列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/listForClerk", p, c),
  },
  armyScore_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/listForSkill", p, c),
  },
  armyScore_listSkillByStudent: {
    /*
     * 列表（职业技能培训）
     * studentId 学生id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/listSkillByStudent", p, c),
  },
  armyScore_scoreInfoForClerk: {
    /*
     * 成绩信息（事务员培训）
     * province 省份 (string query required)
     * year 年份 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyScore/scoreInfoForClerk", p, c),
  },
  armyScore_upload: {
    /*
     * 导入
     * classId 班级id，职业技能的时候必传 (integer query )
     * file file (file formData required)
     * type 类型：事务员培训、职业技能培训、适应性培训 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyScore/upload", p, c),
  },

  /**
   * 结算材料
   */
  armySettleMaterial: {
    /*
     * 添加
     * configId 报名配置id (integer query )
     * id  (integer query )
     * material 材料 (string query )
     * year 年份 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armySettleMaterial", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armySettleMaterial", p, c),
  },
  armySettleMaterial_list: {
    /*
     * 列表
     * configId 配置id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySettleMaterial/list", p, c),
  },

  /**
   * 中军学生名单
   */
  armyStudent: {
    /*
     * 添加
     * age 年龄 (integer query )
     * birth 出生年月 (string query )
     * city 城市 (string query )
     * classId 班级id (integer query )
     * district 区县 (string query )
     * eduLevel 文化程度 (string query )
     * enrollTeacherId 业绩所属人 (integer query )
     * gender 性别 (string query )
     * id  (integer query )
     * idCardNo 身份证号 (string query )
     * loginStatus 是否已登陆 (string query )
     * name 学生姓名 (string query )
     * phone 手机号 (string query )
     * projectId 项目id (integer query )
     * province 省份 (string query )
     * street 所在镇街 (string query )
     * studyLen 学习时长 (integer query )
     * studyProgress 学习进度 (integer query )
     * totalDuration 总时长 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudent", p, c),
  },
  armyStudent_batchAssignClass: {
    /*
     * 批量分班
     * classId 班级id (integer query required)
     * ids id列表 (array query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/batchAssignClass", p, c),
  },
  armyStudent_batchAssignClassForSkill: {
    /*
     * 批量分班
     * classId 班级id (integer query required)
     * ids id列表 (array query required)
     * uploadType 导入类型：新增、覆盖 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyStudent/batchAssignClassForSkill", p, c),
  },
  armyStudent_batchRemove: {
    /*
     * 批量删除
     * ids id列表 (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudent/batchRemove", p, c),
  },
  armyStudent_batchSyncSchoolRollInfo: {
    /*
     * 批量同步合同信息
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyStudent/batchSyncSchoolRollInfo", p, c),
  },
  armyStudent_createAdapt: {
    /*
     * 添加适应性培训学生
     * birth 出生日期|全部|日期|日期| (string query )
     * city 培训地(市)|全部||字符串下拉|api/cms/army/armyProject/listCity?province=${province} (string query )
     * classId 班级id|筛选||ID下拉|api/cms/army/armyClass/listSimple?businessType=适应性培训&year=${year}&province=${province} (integer query )
     * className 班级名称|列表||| (string query )
     * classType 班级类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=适应性培训班级类型 (string query )
     * district 培训地(区)|全部||字符串下拉|api/cms/army/armyProject/listDistrict?province=${province}&city=${city} (string query )
     * eduLevel 文化程度|列表||| (string query )
     * emergencyContactPhone 联系人电话|列表||| (string query )
     * emergencyContactRelationship 联系人关系|列表||| (string query )
     * familyAddress 家庭住址|列表||| (string query )
     * familyCity 家庭住址（市）|列表||| (string query )
     * familyDistrict 家庭住址（区）|列表||| (string query )
     * familyProvince 家庭住址（省）|列表||| (string query )
     * gender 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * hasCert 是否已获取证书|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * id 学生编号|全部||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * major 专业|列表||| (string query )
     * militaryTime 入伍时间|列表|日期|| (string query )
     * month 月份|全部||字符串下拉|api/cms/army/armyProject/listMonth?businessType=适应性培训&year=${year} (string query )
     * name 学生姓名|全部||| (string query )
     * phone 手机号|全部||| (string query )
     * projectType 项目类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军项目类型 (string query )
     * province 培训地(省)|全部||字符串下拉|api/cms/army/armyProject/listProvince (string query )
     * reentry 是否复学|列表||| (string query )
     * site 学校名称|列表||| (string query )
     * siteType 学校性质|列表||| (string query )
     * street 安置地(街道)|列表||| (string query )
     * studentCity 安置地(市)|列表||| (string query )
     * studentDistrict 安置地(区)|列表||| (string query )
     * studentProvince 安置地(省)|列表||| (string query )
     * studyLen 学习时长|全部||数量| (integer query )
     * studyProgress 学习进度|全部|百分比|数量| (integer query )
     * submit 是否已提交|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * totalDuration 总时长|全部||数量| (integer query )
     * year 年份|全部||字符串下拉|api/cms/army/armyProject/listYear (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/createAdapt", p, c),
  },
  armyStudent_createOrUpdateOther: {
    /*
     * 添加编辑其他培训学生
     * birth 出生日期|全部|日期|日期| (string query )
     * city 培训地(市)|全部||字符串下拉|api/cms/army/armyProject/listCity?province=${province} (string query )
     * classId 班级id|筛选||ID下拉|api/cms/army/armyClass/listSimple?businessType=其他&year=${year}&province=${province} (integer query )
     * className 班级名称|列表||| (string query )
     * classType 班级类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=其他培训班级类型 (string query )
     * district 培训地(区)|全部||字符串下拉|api/cms/army/armyProject/listDistrict?province=${province}&city=${city} (string query )
     * gender 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * id 学生编号|全部||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * month 月份|全部||字符串下拉|api/cms/army/armyProject/listMonth?businessType=其他&year=${year} (string query )
     * name 学生姓名|全部||| (string query )
     * phone 手机号|全部||| (string query )
     * projectType 项目类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军项目类型 (string query )
     * province 培训地(省)|全部||字符串下拉|api/cms/army/armyProject/listProvince (string query )
     * street 安置地(街道)|列表||| (string query )
     * studentCity 安置地(市)|列表||| (string query )
     * studentDistrict 安置地(区)|列表||| (string query )
     * studentProvince 安置地(省)|列表||| (string query )
     * studyLen 学习时长|全部||数量| (integer query )
     * studyProgress 学习进度|全部|百分比|数量| (integer query )
     * totalDuration 总时长|全部||数量| (integer query )
     * year 年份|全部||字符串下拉|api/cms/army/armyProject/listYear (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/createOrUpdateOther", p, c),
  },
  armyStudent_detailsSkill: {
    /*
     * 职业技能培训学生详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/detailsSkill", p, c),
  },
  armyStudent_downloadAssignClassModuleForSkill: {
    /*
     * 下载批量分班模板
     */
    get: (p, c) =>
      $.get(
        "/api/cms/army/armyStudent/downloadAssignClassModuleForSkill",
        p,
        c
      ),
  },
  armyStudent_editAdaptForClient: {
    /*
     * 适应性培学生信息编辑
     * age 年龄 (integer query )
     * birth 出生年月 (string query )
     * city 培训地(市) (string query )
     * classId 班级id (integer query )
     * className 班级名称 (string query )
     * district 培训地(区) (string query )
     * eduLevel 文化程度 (string query )
     * emergencyContactPhone 联系人电话 (string query )
     * emergencyContactRelationship 联系人关系 (string query )
     * familyAddress 家庭住址 (string query )
     * familyCity 家庭住址（市） (string query )
     * familyDistrict 家庭住址（区） (string query )
     * familyProvince 家庭住址（省） (string query )
     * gender 性别 (string query )
     * homework 作业 (string query )
     * id id (integer query )
     * idCardNo 身份证号 (string query )
     * major 专业 (string query )
     * militaryTime 入伍时间 (string query )
     * name 学生姓名 (string query )
     * phone 手机号 (string query )
     * province 培训地(省) (string query )
     * reentry 是否复学 (string query )
     * site 学校名称 (string query )
     * siteType 学校性质 (string query )
     * street 所在镇街 (string query )
     * studentCity 安置地(市) (string query )
     * studentDistrict 安置地(区) (string query )
     * studentProvince 安置地(省) (string query )
     * submit 是否已提交 (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/editAdaptForClient", p, c),
  },
  armyStudent_exportEnrollDataForSkill: {
    /*
     * 导出报名数据
     * end 结束时间 (string query )
     * hasEnrolled 是否已报名 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudent/exportEnrollDataForSkill", p, c),
  },
  armyStudent_exportForAdapt: {
    /*
     * 导出（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportForAdapt", p, c),
  },
  armyStudent_exportForClerk: {
    /*
     * 导出(事务员)
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportForClerk", p, c),
  },
  armyStudent_exportForOfficer: {
    /*
     * 导出（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportForOfficer", p, c),
  },
  armyStudent_exportForOther: {
    /*
     * 导出（其他培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportForOther", p, c),
  },
  armyStudent_exportForSkill: {
    /*
     * 导出（职业技能）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportForSkill", p, c),
  },
  armyStudent_exportForSkillByClass: {
    /*
     * 根据班级导出导出（职业技能）
     * classId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudent/exportForSkillByClass", p, c),
  },
  armyStudent_exportSettleDataForSkill: {
    /*
     * 导出结算数据
     * end 结束时间 (string query )
     * hasSettled 是否已结算 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudent/exportSettleDataForSkill", p, c),
  },
  armyStudent_exportSkillWord: {
    /*
     * 导出职业技能学生word
     * ids ids (array query required)
     * moduleName 模板名称 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/exportSkillWord", p, c),
  },
  armyStudent_exportTrainingDataForSkill: {
    /*
     * 导出培训数据
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * status 状态 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudent/exportTrainingDataForSkill", p, c),
  },
  armyStudent_exportWarningForSkill: {
    /*
     * 预警学生导出（职业技能）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudent/exportWarningForSkill", p, c),
  },
  armyStudent_getHomework: {
    /*
     * 获取学习心得
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/getHomework", p, c),
  },
  armyStudent_hasSigned: {
    /*
     * 是否已登录
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/hasSigned", p, c),
  },
  armyStudent_info: {
    /*
     * 个人信息
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/info", p, c),
  },
  armyStudent_infoAdaptForClient: {
    /*
     * 适应性培训个人信息
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/infoAdaptForClient", p, c),
  },
  armyStudent_listClass: {
    /*
     * 班级列表
     * businessType 类型:事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listClass", p, c),
  },
  armyStudent_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listForAdapt", p, c),
  },
  armyStudent_listForClerk: {
    /*
     * 列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listForClerk", p, c),
  },
  armyStudent_listForOfficer: {
    /*
     * 列表（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listForOfficer", p, c),
  },
  armyStudent_listForOther: {
    /*
     * 列表（其他培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listForOther", p, c),
  },
  armyStudent_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listForSkill", p, c),
  },
  armyStudent_listSimple: {
    /*
     * 简易列表
     * classId 班级id (integer query required)
     * name 学生姓名（至少输两个字） (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listSimple", p, c),
  },
  armyStudent_listWarningForSkill: {
    /*
     * 预警学生列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/listWarningForSkill", p, c),
  },
  armyStudent_refreshStudyProgress: {
    /*
     * 刷新学习进度
     * classId 班级id (integer query )
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyStudent/refreshStudyProgress", p, c),
  },
  armyStudent_saveSkillForClient: {
    /*
     * 小程序端添加
     * award 立功奖励情况|列表||| (string query )
     * batch 批次|全部||字符串下拉|api/ems/basic/batch/listPlatformBatch?platform=中军职达 (string query )
     * birth 出生日期|全部|日期|日期| (string query )
     * certCount 取证数量|全部||数量| (integer query )
     * city 培训地(市)|全部||字符串下拉|api/cms/army/armyProject/listCity?province=${province} (string query )
     * classId 班级id|筛选||ID下拉|api/cms/army/armyClass/listSimple?businessType=职业技能培训&year=${year}&province=${province} (integer query )
     * className 班级名称|列表||| (string query )
     * company 工作单位 (string query )
     * createTime 首次提交时间|全部|时间|时间| (string query )
     * diplomaPhoto 毕业证书照片|列表|图片|| (string query )
     * district 培训地(区)|全部||字符串下拉|api/cms/army/armyProject/listDistrict?province=${province}&city=${city} (string query )
     * eduLevel 文化程度|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历 (string query )
     * enrollTeacher 业绩所属人|列表||| (string query )
     * enrollTeacherId 业绩所属人id|筛选||ID下拉|api/bms/system/admin/listAdmin (integer query )
     * familyAddress 家庭住址|列表||| (string query )
     * familyContactInfo 家庭联系人及电话|列表||| (string query )
     * gender 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * hasAssignClass 是否已分班|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * hasEnroll 是否已报名|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * health 健康状况|全部||字符串下拉|api/bms/develop/config/listSelect?key=健康状况 (string query )
     * id 学生编号|全部||| (string query )
     * idCardBackPhoto 身份证背面|列表|图片|| (string query )
     * idCardFrontPhoto 身份证正面|列表|图片|| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * joinArmyTime 入伍年月|全部|时间|时间| (string query )
     * leaveArmyTime 退役年月|全部|时间|时间| (string query )
     * leaveArmyType 退役方式|全部||字符串下拉|api/bms/develop/config/listSelect?key=退役方式 (string query )
     * liveStatus 流失状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=流失状态 (string query )
     * loginStatus 是否已登陆|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * major 专业|列表||| (string query )
     * majorId 专业id|筛选||ID下拉|api/ems/basic/major/listSimple?siteId=${siteId} (integer query )
     * name 学生姓名|全部||| (string query )
     * nonlocalFlag 是否异地培训|列表||| (string query )
     * phone 手机号|全部||| (string query )
     * politicalStatus 政治面貌|全部||字符串下拉|api/bms/develop/config/listSelect?key=政治面貌 (string query )
     * projectId 项目id|无||| (integer query )
     * projectType 项目类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军项目类型 (string query )
     * province 培训地(省)|全部||字符串下拉|api/cms/army/armyProject/listProvince (string query )
     * remark 备注|全部||| (string query )
     * retirementCardPhoto 退役证照片|列表|图片|| (string query )
     * schoolRollId 职业技能合同编号|全部||| (string query )
     * selfPhotoUrl 个人照|列表|图片|| (string query )
     * selfSignTime 最新签名时间|全部|时间|时间| (string query )
     * selfSignUrl 个人签名|列表|图片|| (string query )
     * settleDuration 结算进度|全部|百分比|数量| (integer query )
     * site 学校|列表||| (string query )
     * siteId 学校|筛选||ID下拉|api/ems/basic/site/listSimple?type=退伍军人技能培训 (integer query )
     * status 状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军职业技能学生状态 (string query )
     * street 安置地(街道)|全部||| (string query )
     * studentCity 安置地(市)|全部||| (string query )
     * studentDistrict 安置地(区)|全部||| (string query )
     * studentProvince 安置地(省)|全部||| (string query )
     * studyLen 学习时长|全部||数量| (integer query )
     * studyProgress 学习进度|全部|百分比|数量| (integer query )
     * totalDuration 总时长|全部||数量| (integer query )
     * trainCount 培训次数|全部||数量| (integer query )
     * trainDuration 培训期限|列表||| (string query )
     * vocationalSkillsInfo 就业技能及等级|列表||| (string query )
     * year 年份|全部||字符串下拉|api/cms/army/armyProject/listYear (string query )
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyStudent/saveSkillForClient", p, c),
  },
  armyStudent_searchByIdCardNo: {
    /*
     * 根据身份证号查询职业技能学生信息
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/searchByIdCardNo", p, c),
  },
  armyStudent_setHomework: {
    /*
     * 上传学习心得
     * homework 学习心得 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/setHomework", p, c),
  },
  armyStudent_signIn: {
    /*
     * 登录
     * classId 班级id (integer query required)
     * deviceType 设备类型：移动端、PC端 (string query )
     * idCardNo 身份证号 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/signIn", p, c),
  },
  armyStudent_signOut: {
    /*
     * 退出登录
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudent/signOut", p, c),
  },
  armyStudent_staticsDataForSkill: {
    /*
     * 职业技能统计数据
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     */
    get: (p, c) => $.get("/api/cms/army/armyStudent/staticsDataForSkill", p, c),
  },
  armyStudent_syncSchoolRollInfo: {
    /*
     * 同步合同信息
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/syncSchoolRollInfo", p, c),
  },
  armyStudent_syncSkillStudentStatus: {
    /*
     * 批量同步学生状态
     * classId classId (integer query )
     */
    put: (p, c) =>
      $.put("/api/cms/army/armyStudent/syncSkillStudentStatus", p, c),
  },
  armyStudent_updateAdapt: {
    /*
     * 编辑适应性培训学生
     * birth 出生日期|全部|日期|日期| (string query )
     * city 培训地(市)|全部||字符串下拉|api/cms/army/armyProject/listCity?province=${province} (string query )
     * classId 班级id|筛选||ID下拉|api/cms/army/armyClass/listSimple?businessType=适应性培训&year=${year}&province=${province} (integer query )
     * className 班级名称|列表||| (string query )
     * classType 班级类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=适应性培训班级类型 (string query )
     * district 培训地(区)|全部||字符串下拉|api/cms/army/armyProject/listDistrict?province=${province}&city=${city} (string query )
     * eduLevel 文化程度|列表||| (string query )
     * emergencyContactPhone 联系人电话|列表||| (string query )
     * emergencyContactRelationship 联系人关系|列表||| (string query )
     * familyAddress 家庭住址|列表||| (string query )
     * familyCity 家庭住址（市）|列表||| (string query )
     * familyDistrict 家庭住址（区）|列表||| (string query )
     * familyProvince 家庭住址（省）|列表||| (string query )
     * gender 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * hasCert 是否已获取证书|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * id 学生编号|全部||| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * major 专业|列表||| (string query )
     * militaryTime 入伍时间|列表|日期|| (string query )
     * month 月份|全部||字符串下拉|api/cms/army/armyProject/listMonth?businessType=适应性培训&year=${year} (string query )
     * name 学生姓名|全部||| (string query )
     * phone 手机号|全部||| (string query )
     * projectType 项目类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军项目类型 (string query )
     * province 培训地(省)|全部||字符串下拉|api/cms/army/armyProject/listProvince (string query )
     * reentry 是否复学|列表||| (string query )
     * site 学校名称|列表||| (string query )
     * siteType 学校性质|列表||| (string query )
     * street 安置地(街道)|列表||| (string query )
     * studentCity 安置地(市)|列表||| (string query )
     * studentDistrict 安置地(区)|列表||| (string query )
     * studentProvince 安置地(省)|列表||| (string query )
     * studyLen 学习时长|全部||数量| (integer query )
     * studyProgress 学习进度|全部|百分比|数量| (integer query )
     * submit 是否已提交|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * totalDuration 总时长|全部||数量| (integer query )
     * year 年份|全部||字符串下拉|api/cms/army/armyProject/listYear (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/updateAdapt", p, c),
  },
  armyStudent_updateSkill: {
    /*
     * 编辑职业技能学生
     * award 立功奖励情况|列表||| (string query )
     * batch 批次|全部||字符串下拉|api/ems/basic/batch/listPlatformBatch?platform=中军职达 (string query )
     * birth 出生日期|全部|日期|日期| (string query )
     * certCount 取证数量|全部||数量| (integer query )
     * city 培训地(市)|全部||字符串下拉|api/cms/army/armyProject/listCity?province=${province} (string query )
     * classId 班级id|筛选||ID下拉|api/cms/army/armyClass/listSimple?businessType=职业技能培训&year=${year}&province=${province} (integer query )
     * className 班级名称|列表||| (string query )
     * company 工作单位 (string query )
     * createTime 首次提交时间|全部|时间|时间| (string query )
     * diplomaPhoto 毕业证书照片|列表|图片|| (string query )
     * district 培训地(区)|全部||字符串下拉|api/cms/army/armyProject/listDistrict?province=${province}&city=${city} (string query )
     * eduLevel 文化程度|全部||字符串下拉|api/bms/develop/config/listSelect?key=学历 (string query )
     * enrollTeacher 业绩所属人|列表||| (string query )
     * enrollTeacherId 业绩所属人id|筛选||ID下拉|api/bms/system/admin/listAdmin (integer query )
     * familyAddress 家庭住址|列表||| (string query )
     * familyContactInfo 家庭联系人及电话|列表||| (string query )
     * gender 性别|全部||字符串下拉|api/bms/develop/config/listSelect?key=性别 (string query )
     * hasAssignClass 是否已分班|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * hasEnroll 是否已报名|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * health 健康状况|全部||字符串下拉|api/bms/develop/config/listSelect?key=健康状况 (string query )
     * id 学生编号|全部||| (string query )
     * idCardBackPhoto 身份证背面|列表|图片|| (string query )
     * idCardFrontPhoto 身份证正面|列表|图片|| (string query )
     * idCardNo 身份证号|全部||| (string query )
     * joinArmyTime 入伍年月|全部|时间|时间| (string query )
     * leaveArmyTime 退役年月|全部|时间|时间| (string query )
     * leaveArmyType 退役方式|全部||字符串下拉|api/bms/develop/config/listSelect?key=退役方式 (string query )
     * liveStatus 流失状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=流失状态 (string query )
     * loginStatus 是否已登陆|全部||字符串下拉|api/bms/develop/config/listSelect?key=是否 (string query )
     * major 专业|列表||| (string query )
     * majorId 专业id|筛选||ID下拉|api/ems/basic/major/listSimple?siteId=${siteId} (integer query )
     * name 学生姓名|全部||| (string query )
     * nonlocalFlag 是否异地培训|列表||| (string query )
     * phone 手机号|全部||| (string query )
     * politicalStatus 政治面貌|全部||字符串下拉|api/bms/develop/config/listSelect?key=政治面貌 (string query )
     * projectId 项目id|无||| (integer query )
     * projectType 项目类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军项目类型 (string query )
     * province 培训地(省)|全部||字符串下拉|api/cms/army/armyProject/listProvince (string query )
     * remark 备注|全部||| (string query )
     * retirementCardPhoto 退役证照片|列表|图片|| (string query )
     * schoolRollId 职业技能合同编号|全部||| (string query )
     * selfPhotoUrl 个人照|列表|图片|| (string query )
     * selfSignTime 最新签名时间|全部|时间|时间| (string query )
     * selfSignUrl 个人签名|列表|图片|| (string query )
     * settleDuration 结算进度|全部|百分比|数量| (integer query )
     * site 学校|列表||| (string query )
     * siteId 学校|筛选||ID下拉|api/ems/basic/site/listSimple?type=退伍军人技能培训 (integer query )
     * status 状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=中军职业技能学生状态 (string query )
     * street 安置地(街道)|全部||| (string query )
     * studentCity 安置地(市)|全部||| (string query )
     * studentDistrict 安置地(区)|全部||| (string query )
     * studentProvince 安置地(省)|全部||| (string query )
     * studyLen 学习时长|全部||数量| (integer query )
     * studyProgress 学习进度|全部|百分比|数量| (integer query )
     * totalDuration 总时长|全部||数量| (integer query )
     * trainCount 培训次数|全部||数量| (integer query )
     * trainDuration 培训期限|列表||| (string query )
     * vocationalSkillsInfo 就业技能及等级|列表||| (string query )
     * year 年份|全部||字符串下拉|api/cms/army/armyProject/listYear (string query )
     */
    put: (p, c) => $.put("/api/cms/army/armyStudent/updateSkill", p, c),
  },
  armyStudent_uploadAssignClassForSkill: {
    /*
     * 导入批量分班
     * classId 班级id (integer query required)
     * file file (file formData required)
     * uploadType 导入类型：新增、覆盖 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyStudent/uploadAssignClassForSkill", p, c),
  },
  armyStudent_uploadForAdapt: {
    /*
     * 导入适应性培训
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/uploadForAdapt", p, c),
  },
  armyStudent_uploadForClerk: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/uploadForClerk", p, c),
  },
  armyStudent_uploadForOfficer: {
    /*
     * 导入（转业士官培训）
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/uploadForOfficer", p, c),
  },
  armyStudent_uploadForOther: {
    /*
     * 导入其他培训学生
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/uploadForOther", p, c),
  },
  armyStudent_uploadSkill: {
    /*
     * 导入职业技能
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudent/uploadSkill", p, c),
  },

  /**
   * 学生证书
   */
  armyStudentCert: {
    /*
     * 添加
     * certFile 证书 (string query )
     * certInitTime 证书初始上传时间 (string query )
     * certLastTime 证书最近一次上传时间 (string query )
     * classId 班级id (integer query )
     * id  (integer query )
     * studentId 学生id (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyStudentCert", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudentCert", p, c),
  },
  armyStudentCert_exportForSkill: {
    /*
     * 导出（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentCert/exportForSkill", p, c),
  },
  armyStudentCert_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentCert/listForSkill", p, c),
  },

  /**
   * 中军学生班级（职业技能）
   */
  armyStudentClass: {
    /*
     * 删除学生班级
     * classId 班级id (integer query required)
     * studentId 学生id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudentClass", p, c),
  },
  armyStudentClass_listClassId: {
    /*
     * 获取班级id列表
     * studentId 学生id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudentClass/listClassId", p, c),
  },
  armyStudentClass_restore: {
    /*
     * 修复
     */
    post: (p, c) => $.post("/api/cms/army/armyStudentClass/restore", p, c),
  },

  /**
   * 中军事务员培训学生练习
   */
  armyStudentPaper: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudentPaper", p, c),
  },
  armyStudentPaper_createRandomPaper: {
    /*
     * 生产随即试卷
     * paperId 试卷id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyStudentPaper/createRandomPaper", p, c),
  },
  armyStudentPaper_exportChapterExercise: {
    /*
     * 导出中军事务员章节习题练习情况
     * chapterAliases 章节别名列表，不传则使用配置的全部 (array query )
     * classId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportChapterExercise", p, c),
  },
  armyStudentPaper_exportChapterForClerk: {
    /*
     * 章节练习记录列表导出(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportChapterForClerk", p, c),
  },
  armyStudentPaper_exportChapterForOfficer: {
    /*
     * 章节练习记录列表导出(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportChapterForOfficer", p, c),
  },
  armyStudentPaper_exportChapterForSkill: {
    /*
     * 章节练习记录列表导出(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportChapterForSkill", p, c),
  },
  armyStudentPaper_exportPracticeForClerk: {
    /*
     * 模拟练习记录列表导出(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportPracticeForClerk", p, c),
  },
  armyStudentPaper_exportPracticeForOfficer: {
    /*
     * 模拟练习记录列表导出(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportPracticeForOfficer", p, c),
  },
  armyStudentPaper_exportPracticeForSkill: {
    /*
     * 模拟练习记录列表导出(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportPracticeForSkill", p, c),
  },
  armyStudentPaper_exportRealForClerk: {
    /*
     * 模拟练习记录列表导出(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportRealForClerk", p, c),
  },
  armyStudentPaper_exportRealForOfficer: {
    /*
     * 正考记录列表导出(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportRealForOfficer", p, c),
  },
  armyStudentPaper_exportRealForSkill: {
    /*
     * 正考记录列表导出(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/exportRealForSkill", p, c),
  },
  armyStudentPaper_getArmyChapterAliasConfig: {
    /*
     * 获取事务员习题章节别名
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/getArmyChapterAliasConfig", p, c),
  },
  armyStudentPaper_hand: {
    /*
     * 交卷
     * answerContent 答题内容，json字符串 (string query required)
     * answerTime 答题时常，章节练习时给我0也行 (integer query required)
     * contentId 内容id,章节练习时为章节id,其他为试卷id (integer query required)
     * contentType 大题类型，章节练习时给我 (string query )
     * rightCount 打字题正确打字数量，没有给0 (integer query required)
     * studentPaperId 学生答题id,打乱的情况下一定有，列表里有就给我 (integer query )
     * type 类型：章节练习、模拟练习，全真模拟 (string query required)
     * wordCount 打字题打字数量，没有给0 (integer query required)
     * wordTime 打字题打字时长，没有给0 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armyStudentPaper/hand", p, c),
  },
  armyStudentPaper_handSuccess: {
    /*
     * 交卷成功
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudentPaper/handSuccess", p, c),
  },
  armyStudentPaper_listChapterAliasNames: {
    /*
     * 获取章节别名列表（供前端选择）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listChapterAliasNames", p, c),
  },
  armyStudentPaper_listChapterForClerk: {
    /*
     * 章节练习记录列表(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listChapterForClerk", p, c),
  },
  armyStudentPaper_listChapterForClient: {
    /*
     * C端章节练习记录列表
     * contentId 内容id,章节id (integer query required)
     * contentType 大题类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listChapterForClient", p, c),
  },
  armyStudentPaper_listChapterForOfficer: {
    /*
     * 章节练习记录列表(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listChapterForOfficer", p, c),
  },
  armyStudentPaper_listChapterForSkill: {
    /*
     * 章节练习记录列表(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listChapterForSkill", p, c),
  },
  armyStudentPaper_listPracticeForClerk: {
    /*
     * 模拟练习记录列表(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listPracticeForClerk", p, c),
  },
  armyStudentPaper_listPracticeForOfficer: {
    /*
     * 模拟练习记录列表(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listPracticeForOfficer", p, c),
  },
  armyStudentPaper_listPracticeForSkill: {
    /*
     * 模拟练习记录列表(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listPracticeForSkill", p, c),
  },
  armyStudentPaper_listRealForClerk: {
    /*
     * 全真模拟记录列表(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listRealForClerk", p, c),
  },
  armyStudentPaper_listRealForOfficer: {
    /*
     * 正考记录列表(转业士官培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listRealForOfficer", p, c),
  },
  armyStudentPaper_listRealForSkill: {
    /*
     * 正考记录列表(职业技能培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listRealForSkill", p, c),
  },
  armyStudentPaper_listSubjectForClient: {
    /*
     * C端章节练习详情（题目列表）
     * studentPaperId 练习id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentPaper/listSubjectForClient", p, c),
  },
  armyStudentPaper_read: {
    /*
     * 阅卷
     * id id (integer query required)
     * scores 成绩 (array query required)
     * subjectIds id列表 (array query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudentPaper/read", p, c),
  },
  armyStudentPaper_setArmyChapterAliasConfig: {
    /*
     * 设置事务员习题章节别名
     * aliasName 别名名称 (string query )
     * chapterIds 系统章节ID列表 (array query )
     * id id (string query )
     * operateType 操作类型：添加，修改，删除，清空 (string query )
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyStudentPaper/setArmyChapterAliasConfig", p, c),
  },
  armyStudentPaper_temporarilySave: {
    /*
     * 暂存（只有全真模拟的时候使用）
     * answerContent 答题内容，json字符串 (string query required)
     * contentId 全真模拟试卷id (integer query required)
     * studentPaperId 学生答题id,打乱的情况下一定有，列表里有就给我 (integer query )
     */
    post: (p, c) =>
      $.post("/api/cms/army/armyStudentPaper/temporarilySave", p, c),
  },

  /**
   * 中军学生视频观看记录
   */
  armyStudentVideo_exportForAdapt: {
    /*
     * 导出（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/exportForAdapt", p, c),
  },
  armyStudentVideo_exportForClerk: {
    /*
     * 导出（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/exportForClerk", p, c),
  },
  armyStudentVideo_exportForOfficer: {
    /*
     * 导出（转业士官培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentVideo/exportForOfficer", p, c),
  },
  armyStudentVideo_exportForOther: {
    /*
     * 导出（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/exportForOther", p, c),
  },
  armyStudentVideo_exportForSkill: {
    /*
     * 导出（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/exportForSkill", p, c),
  },
  armyStudentVideo_finish: {
    /*
     * 一键刷完
     * studentId 学生id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudentVideo/finish", p, c),
  },
  armyStudentVideo_getAdaptProgress: {
    /*
     * 获取适应性培训进度
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentVideo/getAdaptProgress", p, c),
  },
  armyStudentVideo_listForAdapt: {
    /*
     * 列表（适应性培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/listForAdapt", p, c),
  },
  armyStudentVideo_listForClerk: {
    /*
     * 列表（事务员培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/listForClerk", p, c),
  },
  armyStudentVideo_listForOfficer: {
    /*
     * 列表（转业士官培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/listForOfficer", p, c),
  },
  armyStudentVideo_listForOther: {
    /*
     * 列表（其他培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/listForOther", p, c),
  },
  armyStudentVideo_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) => $.get("/api/cms/army/armyStudentVideo/listForSkill", p, c),
  },
  armyStudentVideo_progress: {
    /*
     * 修改进度，切换视频（新老视频都调用），返回，播放结束，暂停，HOME等情况调用，学习1分钟
     * chapterId 章节id (integer query required)
     * progress 进度 (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudentVideo/progress", p, c),
  },
  armyStudentVideo_restoreCert: {
    /*
     * 修复证书
     * classIds 班级id (array query required)
     */
    put: (p, c) => $.put("/api/cms/army/armyStudentVideo/restoreCert", p, c),
  },

  /**
   * 错题集
   */
  armyStudentWrongAnswer: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyStudentWrongAnswer", p, c),
  },
  armyStudentWrongAnswer_exportForClerk: {
    /*
     * 导出（事务员培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/exportForClerk", p, c),
  },
  armyStudentWrongAnswer_exportForSkill: {
    /*
     * 导出（职业技能培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/exportForSkill", p, c),
  },
  armyStudentWrongAnswer_listChapterForClient: {
    /*
     * C端错题章节列表
     * type 类型：事务员培训、职业技能培训、适应性培训 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/listChapterForClient", p, c),
  },
  armyStudentWrongAnswer_listForClerk: {
    /*
     * 列表（事务员培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/listForClerk", p, c),
  },
  armyStudentWrongAnswer_listForSkill: {
    /*
     * 列表（职业技能培训）
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/listForSkill", p, c),
  },
  armyStudentWrongAnswer_listSubjectForClient: {
    /*
     * C端错题习题列表
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armyStudentWrongAnswer/listSubjectForClient", p, c),
  },

  /**
   * 中军习题
   */
  armySubject: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * answer 正确答案 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * answerF 答案F (string query )
     * answerG 答案G (string query )
     * answerH 答案H (string query )
     * answerI 答案I (string query )
     * chapterId 章节id (integer query )
     * content 题目 (string query )
     * contentHash 内容hash (string query )
     * contentType 内容类型：单选，多选，判断等 (string query )
     * id  (integer query )
     * logicType 逻辑题型:单选，多选，判断，填空 (string query )
     * pageNo 页码 (integer query )
     * rightCount 正确人次 (integer query )
     * score 分值 (number query )
     * sort 习题序号 (integer query )
     * wrongCount 错误人次 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armySubject", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armySubject", p, c),
  },
  armySubject_exportForClerk: {
    /*
     * 导出(事务员培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/exportForClerk", p, c),
  },
  armySubject_exportForOfficer: {
    /*
     * 导出(转业士官培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/exportForOfficer", p, c),
  },
  armySubject_exportForSkill: {
    /*
     * 导出(职业技能培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/exportForSkill", p, c),
  },
  armySubject_listContentType: {
    /*
     * 大题列表
     * ableStatus 启用状态 (string query )
     * chapterType 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     * classId 班级id (integer query )
     * courseId 课程id (integer query )
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/listContentType", p, c),
  },
  armySubject_listContentTypeByChapterId: {
    /*
     * 大题列表
     * chapterId 章节id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySubject/listContentTypeByChapterId", p, c),
  },
  armySubject_listContentTypeCount: {
    /*
     * 大题数量
     * chapterIds 章节id (array query )
     * chapterType 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     * classId 班级id (integer query required)
     * courseId 课程id (integer query )
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySubject/listContentTypeCount", p, c),
  },
  armySubject_listForClerk: {
    /*
     * 列表(事务员培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/listForClerk", p, c),
  },
  armySubject_listForOfficer: {
    /*
     * 列表(转业士官培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/listForOfficer", p, c),
  },
  armySubject_listForSkill: {
    /*
     * 列表(职业技能培训)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/listForSkill", p, c),
  },
  armySubject_listSubjectByChapterIdAndContentType: {
    /*
     * 小题列表
     * chapterId 章节id (integer query required)
     * contentType 大题类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/army/armySubject/listSubjectByChapterIdAndContentType",
        p,
        c
      ),
  },
  armySubject_paperComposition: {
    /*
     * 组卷
     * chapterIds 章节id (array query )
     * chapterType 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     * classId 班级id (integer query required)
     * contentTypes 大题类型 (array query required)
     * counts 数量 (array query required)
     * courseId 课程id (integer query )
     * sortByWrongRate 根据错误率排序，不为空且=1 (integer query )
     * type 类型：模拟练习、全真模拟 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySubject/paperComposition", p, c),
  },
  armySubject_paperCompositionByExcel: {
    /*
     * excel表格组卷
     * chapterType 类型：事务员培训、职业技能培训、适应性培训、转业士官培训 (string query required)
     * classId 班级id (integer query required)
     * courseId 课程id (integer query )
     * file file (file formData required)
     * paperType 试卷类型：模拟练习、全真模拟 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/army/armySubject/paperCompositionByExcel", p, c),
  },
  armySubject_refresh: {
    /*
     * 刷新
     * chapterType 类型 (string query required)
     * courseId 课程id (integer query )
     */
    put: (p, c) => $.put("/api/cms/army/armySubject/refresh", p, c),
  },
  armySubject_refreshCacheByChapterId: {
    /*
     * 刷新缓存
     * chapterId 章节id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/cms/army/armySubject/refreshCacheByChapterId", p, c),
  },
  armySubject_upload: {
    /*
     * 导入
     * courseId 课程id (integer query )
     * file file (file formData required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/cms/army/armySubject/upload", p, c),
  },

  /**
   * 中军问卷调查
   */
  armySurvey: {
    /*
     * 添加
     * classId 班级id (integer query )
     * configContent 分值配置 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * openId 开启人 (integer query )
     * startTime 开始时间 (string query )
     * subjects 题目 (string query )
     * type 问卷类型：满意度、生活补贴 (string query )
     */
    post: (p, c) => $.post("/api/cms/army/armySurvey", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armySurvey", p, c),
  },
  armySurvey_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurvey/details", p, c),
  },
  armySurvey_exortChoiceSatisfaction: {
    /*
     * 导出选择题目统计情况
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exortChoiceSatisfaction", p, c),
  },
  armySurvey_exportSatisfactionForAdapt: {
    /*
     * 满意度调查列表导出(适应性培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exportSatisfactionForAdapt", p, c),
  },
  armySurvey_exportSatisfactionForClerk: {
    /*
     * 满意度调查列表导出(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exportSatisfactionForClerk", p, c),
  },
  armySurvey_exportSatisfactionForOther: {
    /*
     * 满意度调查列表导出(其他)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exportSatisfactionForOther", p, c),
  },
  armySurvey_exportSatisfactionForSkill: {
    /*
     * 满意度调查列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exportSatisfactionForSkill", p, c),
  },
  armySurvey_exportSubsidyForSkill: {
    /*
     * 补贴资料收集列表导出
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/exportSubsidyForSkill", p, c),
  },
  armySurvey_getChoiceSatisfaction: {
    /*
     * 获取选择题目统计情况
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/getChoiceSatisfaction", p, c),
  },
  armySurvey_getConfig: {
    /*
     * 获取分值配置
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurvey/getConfig", p, c),
  },
  armySurvey_getSatisfactionSubjects: {
    /*
     * 获取满意度题目
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/getSatisfactionSubjects", p, c),
  },
  armySurvey_getSubsidySubjects: {
    /*
     * 获取补贴资料收集题目
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurvey/getSubsidySubjects", p, c),
  },
  armySurvey_listSatisfactionChoiceSubject: {
    /*
     * 满意度调查选择题目列表
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/listSatisfactionChoiceSubject", p, c),
  },
  armySurvey_listSatisfactionForAdapt: {
    /*
     * 满意度调查列表(适应性培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/listSatisfactionForAdapt", p, c),
  },
  armySurvey_listSatisfactionForClerk: {
    /*
     * 满意度调查列表(事务员培训)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/listSatisfactionForClerk", p, c),
  },
  armySurvey_listSatisfactionForOther: {
    /*
     * 满意度调查列表(其他)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/listSatisfactionForOther", p, c),
  },
  armySurvey_listSatisfactionForSkill: {
    /*
     * 满意度调查列表(职业技能)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurvey/listSatisfactionForSkill", p, c),
  },
  armySurvey_listSubsidyForSkill: {
    /*
     * 补贴资料收集列表
     */
    get: (p, c) => $.get("/api/cms/army/armySurvey/listSubsidyForSkill", p, c),
  },
  armySurvey_updateConfig: {
    /*
     * 更新分值配置
     * configContent 分值配置 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armySurvey/updateConfig", p, c),
  },
  armySurvey_updateSubjects: {
    /*
     * 更新题目
     * id id (integer query required)
     * subjects 题目 (string query required)
     */
    put: (p, c) => $.put("/api/cms/army/armySurvey/updateSubjects", p, c),
  },

  /**
   * 中军问卷调查记录
   */
  armySurveyRecord: {
    /*
     * 编辑（只能编辑补贴资料收集）
     * content 内容 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/army/armySurveyRecord", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armySurveyRecord", p, c),
  },
  armySurveyRecord_clear: {
    /*
     * 清空
     * surveyId 问卷id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armySurveyRecord/clear", p, c),
  },
  armySurveyRecord_exportSatisfaction: {
    /*
     * 导出满意度调查记录列表（未提交的也会展示）
     * classId 班级id (integer query required)
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurveyRecord/exportSatisfaction", p, c),
  },
  armySurveyRecord_exportSubsidy: {
    /*
     * 导出补贴资料收集记录列表（未提交的也会展示）
     * classId 班级id (integer query required)
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurveyRecord/exportSubsidy", p, c),
  },
  armySurveyRecord_getAnswers: {
    /*
     * 获取答案
     * serialNumber 题目序号 (integer query required)
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurveyRecord/getAnswers", p, c),
  },
  armySurveyRecord_getSatisfactionStatics: {
    /*
     * 满意度问卷调查统计
     * serialNumber 题目序号，不传则表示所有 (integer query )
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurveyRecord/getSatisfactionStatics", p, c),
  },
  armySurveyRecord_listSatisfaction: {
    /*
     * 满意度调查记录列表（未提交的也会展示）
     * classId 班级id (integer query required)
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurveyRecord/listSatisfaction", p, c),
  },
  armySurveyRecord_listSubsidy: {
    /*
     * 导出职业技能补贴资料收集记录列表（未提交的也会展示）
     * classId 班级id (integer query required)
     * surveyId 问卷id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurveyRecord/listSubsidy", p, c),
  },
  armySurveyRecord_satisfactionAnswer: {
    /*
     * 满意度问卷调查答案
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/army/armySurveyRecord/satisfactionAnswer", p, c),
  },
  armySurveyRecord_submit: {
    /*
     * 提交问卷调查记录
     * content 内容 (string query required)
     * studentId 学生id (integer query required)
     * surveyId 问卷id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/army/armySurveyRecord/submit", p, c),
  },
  armySurveyRecord_subsidyAnswer: {
    /*
     * 补贴资料收集答案
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armySurveyRecord/subsidyAnswer", p, c),
  },

  /**
   * 中军培训配置
   */
  armyTrainConfig: {
    /*
     * 添加
     * adminId 负责人 (integer query )
     * area 区 (string query )
     * batch 批次 (string query )
     * brochures 宣传手册 (string query )
     * city 市 (string query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * province 省 (string query )
     * settleRequirement 结算要求 (string query )
     * sorting 排序 (integer query )
     * trainDuration 培训要求时长 (integer query )
     */
    post: (p, c) => $.post("/api/cms/army/armyTrainConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/army/armyTrainConfig", p, c),
  },
  armyTrainConfig_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/army/armyTrainConfig/export", p, c),
  },
  armyTrainConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/army/armyTrainConfig/list", p, c),
  },
  armyTrainConfig_listMajor: {
    /*
     * 专业列表
     * area 区 (string query required)
     * batch 批次 (string query required)
     * city 市 (string query required)
     * province 省 (string query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyTrainConfig/listMajor", p, c),
  },
  armyTrainConfig_listSite: {
    /*
     * 学校列表
     * area 区 (string query required)
     * batch 批次 (string query required)
     * city 市 (string query required)
     * province 省 (string query required)
     */
    get: (p, c) => $.get("/api/cms/army/armyTrainConfig/listSite", p, c),
  },
  armyTrainConfig_upload: {
    /*
     * upload
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/cms/army/armyTrainConfig/upload", p, c),
  },
};
